/**
 * @generated SignedSource<<97f81c89f8d7fe2b9755bec45da3c939>>
 * @relayHash 761523a5c13b7bf30fcd6a8f6f952507
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 72cf94a29af81fc83cb33e6e1094b2ecc857aa26a8b94dcb45f9c02da4f9088c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type people_peopleEditSearchRefetchQuery$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  id: string;
  searchBy?: string | null | undefined;
};
export type people_peopleEditSearchRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"people_issueFieldPeopleEditviewFull_PeopleEditViewWithFieldOptionsFragmentNew_suggestionsFragmentRef">;
};
export type people_peopleEditSearchRefetchQuery = {
  response: people_peopleEditSearchRefetchQuery$data;
  variables: people_peopleEditSearchRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 50,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "searchBy"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v4 = {
  "kind": "Variable",
  "name": "searchBy",
  "variableName": "searchBy"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v4/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "people_peopleEditSearchRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "people_issueFieldPeopleEditviewFull_PeopleEditViewWithFieldOptionsFragmentNew_suggestionsFragmentRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "people_peopleEditSearchRefetchQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v6/*: any*/),
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "users",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "accountId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "picture"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "accountStatus"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "email"
                              }
                            ],
                            "type": "AtlassianAccountUser"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v6/*: any*/),
                "filters": [
                  "searchBy"
                ],
                "handle": "connection",
                "key": "people_issueFieldPeopleEditviewFull_users",
                "kind": "LinkedHandle",
                "name": "users"
              }
            ],
            "type": "JiraPeopleField"
          },
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "72cf94a29af81fc83cb33e6e1094b2ecc857aa26a8b94dcb45f9c02da4f9088c",
    "metadata": {},
    "name": "people_peopleEditSearchRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2d072117ae7399cffa04ad290efe606d";

export default node;
